import { Component } from '@angular/core';
import { LifecycleOptionsComponent } from '../lifecycle-options/lifecycle-options.component';
import * as LifecycleStageFuncs from '../lifecycle-options/consts';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-account-group-lifecycle-options',
  templateUrl: '../lifecycle-options/account-group-lifecycle-options.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class AccountGroupLifecycleOptionsComponent extends LifecycleOptionsComponent {
  lifecycleOptions = LifecycleStageFuncs.allStageOptions();
}
